import { render, staticRenderFns } from "./array.vue?vue&type=template&id=21237544&"
import script from "./array.vue?vue&type=script&lang=js&"
export * from "./array.vue?vue&type=script&lang=js&"
import style0 from "./array.vue?vue&type=style&index=0&id=21237544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports